<template>
  <section
    class="insurance borderline--left my-1 c--white"
    :class="{'borderline--active':insurance.selected}"
    :aria-checked="insurance.selected"
  >
    <div class="grid">
      <div class="grid__col grid__col--12 py-1 px-2">
        <div class="form__field form__field--checkbox mb-0">
          <input
            v-if="!store.insuranceQues"
            class="form__item"
            :id="uuid"
            type="checkbox"
            :checked="insurance.selected"
            @click="doClick">
          <input
            v-if="store.insuranceQues"
            class="form__item"
            :id="uuid"
            type="checkbox"
            :checked="insurance.selected"
            @click="doClickGb(insurance.id)">
          <label class="form__label form__label--with-headline label-indent" :for="uuid">
            <h3 class="headline-4">
              <small
                v-if="insurance.requiredByLaw"
                class="f--right text--uppercase bodytext-sm">{{t('InsuranceItemRequiredByLaw')}}</small>
              <div class="form__label-text t--bold">{{ insurance.title }}</div>
            </h3>
          </label>

          <div class="insurance__content ml-2 ml-2-indent">
            <vue-details
              class="py-1"
              :class="insurance.readmore.class"
              :summary="insurance.description"
              :open="insurance.open"
              @toggle="insurance.open = !insurance.open">
              <div v-html="insurance.readmore.markup"></div>
            </vue-details>
          </div>

        </div>
      </div>

    </div>

    <section class="c--grey-7 insurance__sub" v-for="(subInsurance, subIndex) in insurance.subInsurances" :key="'insurances_sub_'+subIndex">
      <div class="grid">
        <div class="grid__col grid__col--12 py-1">
          <div v-if="!store.insuranceQues" class="insurance__sub-content pl-4 pl-4-indent">
            <h4 class="bodytext-lg t--bold">{{subInsurance.title}}</h4>

            <vue-details
              class="py-1"
              :class="subInsurance.readmore.class"
              :summary="subInsurance.description"
              :open="subInsurance.open"
              @toggle="subInsurance.open = !subInsurance.open">
              <div v-html="subInsurance.readmore.markup"></div>
            </vue-details>

          </div>
          <div v-if="store.insuranceQues" class="insurance__sub-content pl-4 form__field form__field--checkbox pl-4-indent">
            <input
              class="form__item"
              :id="subInsurance.id"
              type="checkbox"
              :checked="subInsurance.selected"
              @click="doHandleToogleGb(subInsurance.id)"
              :disabled="!insurance.selected">
            <label class="form__label form__label--with-headline" :for="subInsurance.id">
              <h4 class="bodytext-lg t--bold">{{subInsurance.title}}</h4>
            </label>
            <vue-details
              class="py-1"
              :class="subInsurance.readmore.class"
              :summary="subInsurance.description"
              :open="subInsurance.open"
              @toggle="subInsurance.open = !subInsurance.open">
              <div v-html="subInsurance.readmore.markup"></div>
            </vue-details>

          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import t from './../../../mixins/t.js'
import VueDetails from './../../common/VueDetails'

export default {
  name: 'InsuranceItem',
  props: {
    insurance: {
      type: Object
    }
  },
  data () {
    return {
      store: this.$parent.$parent.store
    }
  },
  mixins: [t],
  components: {
    VueDetails
  },
  computed: {
    uuid () {
      return 'checkbox_' + this.insurance.id
    }
  },
  methods: {
    doClick () {
      this.$emit('toogle')
    },
    doClickGb (id) {
      this.$emit('toogle')
      let currentInsurance = this.store.insurances.filter(insurance => {
        if (insurance.id === id && insurance.subInsurances && insurance.selected === false) {
          return insurance
        }
      })
      if (currentInsurance) {
        for (let i = 0; i < currentInsurance.length; i++) {
          for (let j = 0; j < currentInsurance[i].subInsurances.length; j++) {
            if (currentInsurance[i].subInsurances[j].selected === true) {
              currentInsurance[i].subInsurances[j].selected = !currentInsurance[i].subInsurances[j].selected
            }
          }
        }
      }
    },
    doHandleToogleGb (id) {
      let insurancesWithSub = this.store.insurances.filter(insurance => {
        if (insurance.subInsurances) {
          return insurance
        }
      })
      for (let i = 0; i < insurancesWithSub.length; i++) {
        for (let j = 0; j < insurancesWithSub[i].subInsurances.length; j++) {
          if (insurancesWithSub[i].subInsurances[j].id === id) {
            insurancesWithSub[i].subInsurances[j].selected = !insurancesWithSub[i].subInsurances[j].selected
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.insurance {
  border: 0.063rem solid #dfdfdf;
}
.insurance__sub {
  border-top: 0.063rem solid #dfdfdf;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/insurances/InsuranceItem.vue